import { useI18n } from "@shopify/react-i18n";

import en from "./en.json";
import it from "./it.json";

var prefix;
var i18n;

/**
 * dangerouslySetInnerHTML permette di inserire html nel testo
 *
 * @param {string} key
 * @param  {...any} params
 * @returns
 */
export function t(key, ...params) {
  return i18n.translate(prefix + "." + key);
}

export function getI18n() {
  return i18n;
}

export function useTranslations(id = "App") {
  prefix = id;
  [i18n] = useI18n({
    id: id,
    fallback: en,
    translations(locale) {
      if (locale == "it") return it;
      else if (locale == "en") return en;
    },
  });
}

export function sanitizeLocale(locale = null) {
  let sanitizedLocale = "en";
  if (locale === "it" || locale === "it-IT") {
    sanitizedLocale = "it";
  } else if (locale?.startsWith("en")) {
    sanitizedLocale = "en";
  } else sanitizedLocale = null;
  return sanitizedLocale;
}
